(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/contexts/campaign-context-provider.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/contexts/campaign-context-provider.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createContext,
  useCallback
} = React;
const {
  campaign: {
    openCampaignApi,
    CONSTANTS: CAMPAIGN_CONSTANTS
  },
  productMapping
} = svs.numbergames;
const CampaignContext = createContext({});
const CampaignContextProvider = _ref => {
  let {
    children
  } = _ref;
  const hasActiveCampaign = useCallback((productNumeric, drawNumber) => openCampaignApi.hasOpenCampaign(productNumeric, {
    draw: {
      productNumeric,
      drawNumber
    },
    drawTypeId: CAMPAIGN_CONSTANTS.DRAW_TYPE.CAMPAIGN
  }), []);
  const getCampaignChances = useCallback(_ref2 => {
    let {
      productNumeric,
      drawNumber,
      totalPrice,
      game
    } = _ref2;
    return openCampaignApi.calculateChances(productNumeric, {
      wager: _objectSpread(_objectSpread({}, game), {}, {
        productNumeric,
        totalPrice,
        hasLotto2: productMapping.isLotto(productNumeric)
      }),
      draw: {
        productNumeric,
        drawNumber,
        drawCount: 1
      }
    });
  }, []);
  const getCampaignInfo = useCallback((productNumeric, drawNumber) => openCampaignApi.getCampaign(productNumeric, {
    draw: {
      productNumeric,
      drawNumber
    }
  }), []);
  return React.createElement(CampaignContext.Provider, {
    value: {
      hasActiveCampaign,
      getCampaignInfo,
      getCampaignChances
    }
  }, children);
};
Object.assign(svs.numbergames.fractiongames.contexts, {
  CampaignContext,
  CampaignContextProvider
});

 })(window);